export {default as data} from './index.json';
import {Component} from 'intact';
import template from './index.vdt';

import {bind} from 'kpc';
import {TourStepProps} from 'kpc';

export default class extends Component {
    static template = template;
    static defaults() {
        return {
            currentStep: 0 as number,
            showTour: false,  // 默认不显示
            tourData: [
                {
                    target: '#btn1',
                    title: '第一步',
                    content: '这是第一步的引导说明',
                    position: 'bottom'
                },
                {
                    target: '#btn2',
                    title: '第二步',
                    content: '这是第二步的引导说明',
                    position: 'right'
                }
            ]
        };
    }

    @bind
    settour() {
        this.set({
            showTour: true,
            currentStep: 0
        });
    }

    @bind
    close() {
        this.set({
            showTour: false
        });
    }
}